import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Breadcrumb-tw-styles';

class Breadcrumb extends PureComponent {
  render() {
    const { component: Component, className, children, ...other } = this.props;

    return (
      <Component
        className={classNames(styles.breadcrumb.wrapper, className)}
        {...other}
      >
        {children}
      </Component>
    );
  }
}

Breadcrumb.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node.isRequired,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

Breadcrumb.defaultProps = {
  component: 'ul',
  className: '',
};

export default Breadcrumb;
